import { breakpoints } from './variables';
import { debounce } from '../global/helpers';

const backToTop = {

	init() {
		this.header = document.getElementById('js-site-header');
		this.trigger = document.getElementById('js-back-to-top');
		this.isiBar = document.getElementById('js-isi-bar');

		this.handleTriggerOffset = this.handleTriggerOffset.bind(this);
		window.addEventListener('resize', debounce(this.handleTriggerOffset));
		window.addEventListener('scroll', this.handleTriggerOffset);

		this.handleTriggerVisibility = this.handleTriggerVisibility.bind(this);
		window.addEventListener('resize', debounce(this.handleTriggerVisibility));
		window.addEventListener('scroll', this.handleTriggerVisibility);

		this.handleTriggerOffset();
		this.handleTriggerVisibility();
	},

	handleTriggerOffset() {
		let offset = breakpoints.lg.aboveMin() ? 15 : 10;
		if (this.isiBar && !this.isiBar.classList.contains('hide')) {
			offset += this.isiBar.clientHeight;
		}
		this.trigger.style.bottom = `${offset}px`;
	},

	handleTriggerVisibility() {
		const rect = this.header.getBoundingClientRect();
		if (rect.bottom <= 0) {
			this.trigger.classList.add('show');
		} else {
			this.trigger.classList.remove('show');
		}
	},
};

backToTop.init();
